import request from '@/utils/request'
const api = {
  GetById: '/Article/GetById',
  GetListByCategoryId: '/Article/GetListByCategoryId',
  GetSubCategoryList: '/CategoryManage/GetSubCategoryList',
  GetZtbType: '/Portal/GetZtbType',
  GetinfoType: '/Portal/GetinfoType'
}
export function GetById (param) {
  return request({
    url: api.GetById,
    method: 'get',
    params: param
  })
}

export function GetListByCategoryId (param) {
  return request({
    url: api.GetListByCategoryId,
    method: 'get',
    params: param
  })
}
export function GetSubCategoryList (param) {
  return request({
    url: api.GetSubCategoryList,
    method: 'get',
    params: param
  })
}
export function GetZtbType (param) {
  return request({
    url: api.GetZtbType,
    method: 'get',
    params: param
  })
}
export function GetinfoType (param) {
  return request({
    url: api.GetinfoType,
    method: 'get',
    params: param
  })
}



// WEBPACK FOOTER //
// ./src/api/article/index.js